import { useMemo } from 'react';
import { extractWidgetJson } from '../../../../../shared/active-widget/utils';
import { RESTORE_NOTIFICATION_WIDGET } from '../../RestoreNotificationWidget/RestoreNotificationWidget';
export const useHasSubsequentRestoreNotification = config => {
  return useMemo(() => {
    if (!config.messages || config.messageIndex === undefined) {
      return false;
    }
    return config.messages.some((message, index) => {
      const widgetData = extractWidgetJson(message);
      return message.role === 'assistant' && (widgetData == null ? void 0 : widgetData.widget) === RESTORE_NOTIFICATION_WIDGET && index > config.messageIndex;
    });
  }, [config.messages, config.messageIndex]);
};
//# sourceMappingURL=useHasSubsequentRestoreNotification.js.map